module.exports = __webpack_public_path__ + "static/img/AF.54df32f6.png";